module.exports = __webpack_public_path__ + "static/share-e14893e2ff20f205b8903c6f72ff99b5.png";